import { pickGmwLibraryFields } from "../../../schema/gmw-schema-library";

import type { SourcedocumentDataSchemaFor } from "./_gmw-event-schema-collection";

export const gmwShiftSchema: SourcedocumentDataSchemaFor<"GMW_Shift"> = {
  type: "object",
  title: "Gebeurtenis gegevens",
  required: ["eventDate", "groundLevelPosition", "groundLevelPositioningMethod"],
  properties: pickGmwLibraryFields([
    "eventDate",
    "groundLevelPosition",
    "groundLevelPositioningMethod",
  ]),
};
